module.exports = __webpack_public_path__ + "img/天府五中.523cd7e7.jpg";